import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { sendNotification } from "src/redux/actions/notifications";
import { addSpecial, deleteSpecial, findAllSpecial } from "src/redux/actions/special";
import { withRouter, Link } from "react-router-dom";
import { findAllSites } from 'src/redux/actions/sites';
import { addStock, deleteStock, findAllStock } from 'src/redux/actions/stock';
import { findAllUsers } from 'src/redux/actions/admin';

class Special extends Component {
  render = () => {
    const {
      Layout,
      special,
      user,
      users,
      findAllSpecial,
      addSpecial,
      deleteSpecial,
      findAllSites,
      sites,
      stock,
      findAllStock,
      findAllUsers,
      addStock,
      deleteStock,
      sendNotification,
      push,
      history,
      findAllSpecialUpdatedToday,
    } = this.props;
    return (
      <Layout
        special={special}
        user={user}
        users={users}
        addSpecial={addSpecial}
        stock={stock}
        findAllStock={findAllStock}
        findAllUsers={findAllUsers}
        addStock={addStock}
        deleteStock={deleteStock}
        findAllSpecial={findAllSpecial}
        deleteSpecial={deleteSpecial}
        sendNotification={sendNotification}
        findAllSites={findAllSites}
        sites={sites}
        push={push}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  special: state.special.allSpecial || [],
  stock: state.stock.allStock || [],
  sites: state.sites.allSites,
  user: state.user.user || {},
  users: state.admin.allUsers || [],
});

const mapDispatchToProps = {
  findAllStock,
  findAllUsers,
  addStock,
  deleteStock,
  addSpecial,
  deleteSpecial,
  findAllSpecial,
  sendNotification,
  findAllSites,
  push,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Special)
);
